import { Box, Grid, Typography } from "@material-ui/core";
import signedUpImage from "../../images/signedUp.svg";
import { I18n } from "react-redux-i18n";
import { useTheme } from "@material-ui/styles";
import FormButton from "./FormButton";
import { useMount } from "react-use";
import { AUTHENTICATOR_SIGNIN } from "./constants";

const SignupWelcome = ({ setAuthScreen, setInitialValue, initialValue }) => {
  const theme = useTheme();

  useMount(() => {
    setInitialValue({
      ...initialValue,
      password: "",
    });
  });

  return (
    <Grid container spacing={1}>
      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img
          src={signedUpImage}
          alt="welcome avatar"
          style={{ width: "117px", height: "127px" }}
        />
      </Grid>

      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography
          variant="h4"
          color="primary"
          style={{
            fontFamily: "'Paytone One', sans- serif",
          }}
        >
          {I18n.t("authenticator.congratulations")}
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography style={{ color: theme.palette.auth.readonly }}>
          {I18n.t("authenticator.congratulationsText")}
        </Typography>
      </Grid>

      <Box
        style={{ alignSelf: "center", margin: "20px auto" }}
        component="form"
        onSubmit={() => setAuthScreen(AUTHENTICATOR_SIGNIN)}
      >
        <FormButton {...{ label: I18n.t("authenticator.signIn") }} />
      </Box>
    </Grid>
  );
};

export default SignupWelcome;
